<template>

  <main class="post" :style="{ background: 'white' }">


    <div class="blog-post"> 
          
      <div v-if="!loaded">
        <loading-spinner class="spinner"></loading-spinner>
      </div>
    
      <BlogPostHeader v-if="loaded" :post="post"/>

      <div class="blog-post__content"  v-if="loaded" >
        <cmscontent :content="post.content ? post.content.rendered : ''"/>
      </div>

    </div>

    <CommentContainer v-if="allowedComments" :post="post" />
    <RelatedPosts v-if="loaded" :post="post" />  

    <Footer/>

  </main>
</template>
 
<script>
import Footer from '../../components/Footer/Footer.vue';
import BlogPostHeader from '../../components/Blog/BlogPostHeader.vue';
import RelatedPosts from '../../components/Blog/RelatedPosts.vue';
import CommentContainer from '../../components/Comments/CommentContainer.vue';

export default {

  data() {
    return {
      post: null,
      loaded: false,
      timer: null,
      allowedComments: true
    }
  },

  components: {
    Footer,
    BlogPostHeader,
    RelatedPosts,
    CommentContainer
  },

  computed: {
    posts() {
      return this.$store.state.posts;
    },
    relatedPosts() {
      return this.$store.state.relatedPosts;
    },
  },

  mounted() {
    this.getPostBySlug();
    this.$store.commit('setHasComments', this.allowedComments);
  },

  methods: {
    getPostBySlug() {
      const slug = this.$route.params.slug;

      this.$store.dispatch('getPost', slug).then(data => {


        if (!data) {
          return this.$router.push('/404');
        }

        // Add gradient background if there is no img
        if (!data.category_img) {
            let scrollPost = document.querySelector('.scroll-post');
            scrollPost.classList.add('gradient-bg');
        }
        this.$store.commit('setCurrent', data.id);

        const slide = {
          ...data,
          video: data.acf.video,
          img: data.featured_image_src.full[0],
          title: data.title.rendered,
          url: data.link,
          excerpt: data.excerpt.rendered,
          color: data.acf.color_theme || 'white',
          themeColor: data.acf.theme_color || 'white',
          buttonClass: data.acf.button_style
        };

        this.$store.commit('setHeroAndNavigate', {
          slide
        });

      
      this.post = data; 
      this.$store.commit('setPost', this.post);
      this.allowedComments = this.post.comment_status === 'open' ? true : false;

      this.timer = setTimeout(() => this.loaded = true, 600);

      }, rejected => {
        return this.$router.push('/404');
      });
    },


  },

  watch: {
      '$route'(to, from) {
        this.getPostBySlug();
        this.$store.commit('setHasComments', this.allowedComments);
      },
    }


};
</script>

<style lang="scss" scoped>


</style>